/**
 * 手机号输入框里"客户真正敲进去的内容"。
 *
 * ## 为什么需要这一层
 *
 * 「个人资料」页同时有资料卡和「修改密码」卡，密码框带 `autocomplete=
 * current-password`。手机号输入框正好是**密码框之前最后一个文本框**，
 * 又没写 `autocomplete`，浏览器就把「用户名/邮箱」这条启发式套在它身上 ——
 * 打开页面时邮箱被自动填进手机号框，看上去像"客户自己登记过手机号是邮箱"，
 * 而且立刻亮起"有未保存的改动"。
 *
 * 根因已经修在标签上（三个框分别写了 username / name / tel），但自动填充是
 * 浏览器行为，写法挡不干净：密码管理器、扩展、旧版本都可能绕过。
 *
 * 所以这里再加一道**只针对不可能出现的字符**的兜底：手机号里不可能有 `@`，
 * 出现就说明这个值是别的东西被塞进来的。
 *
 * 刻意不做得更聪明：不猜"这是不是某个国家的号码"、不截断、不格式化、不去空格
 * —— 那些规则与 `normalizePhone` 重复，两处早晚漂移成两套（失焦时的就地抹平
 * 是另一件事，见输入框的 onBlur）。这里只回答一个问题：
 * 这个字符序列有可能是客户自己敲的手机号吗？
 *
 * @returns 可以放进输入框的值；`null` 表示"这不是手机号"，调用方应把
 *          DOM 退回当前 state，而不是把它当成客户的输入。
 */
export function phoneTypingValue(raw: string): string | null {
  // `@` 不会出现在任何手机号写法里，但一定出现在邮箱里
  if (raw.includes('@')) return null;
  return raw;
}
